import gsap from 'gsap';

export default function initOpenClose() {
  const classActive = 'is-open';

  document.querySelectorAll('[data-dropdown]').forEach(dropdown => {
    const opener = dropdown.querySelector('[data-opener]');
    const panel = dropdown.querySelector('[data-panel]');

    if (!opener || !panel) return;

    opener.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    gsap.set(panel, { height: 0, overflow: 'hidden' });

    opener.addEventListener('click', () => {
      const isOpen = dropdown.classList.contains(classActive);
      isOpen ? close() : open();
    });

    function open() {
      dropdown.classList.add(classActive);
      opener.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');

      gsap.killTweensOf(panel);
      gsap.fromTo(panel,
        { height: 0, overflow: 'hidden' },
        { height: 'auto', duration: 0.4, clearProps: 'height,overflow' }
      );
    }

    function close() {
      gsap.killTweensOf(panel);
      dropdown.classList.remove(classActive);
      gsap.set(panel, { height: panel.scrollHeight, overflow: 'hidden' });
      gsap.to(panel, { height: 0, duration: 0.4, onComplete() {
        opener.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
      }});
    }
  });
}
